// Estonian

export default {

  component: {
    jobAdList: {
      title: 'Avatud tööpakkumised',
      jobs: 'töökohad',
      noJobAds: 'Hetkel pole ühtegi avatud tööpakkumist.',
    },

    jobAdCard: {
      openUntil: date => `Avatud kuni ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Täname.',
      readyInfo: 'Teie avaldus on laekunud ja värbaja võtab teiega peatselt ühendust.',
      luck: 'Kivi kotti!',
    },

    jobAdSeeYou: {
      title: 'Täname.',
      description: 'Teie kandideerimise avaldus on salvestatud, saatsime teile lingi, et saaksite hiljem kandideerimist jätkata.',
    },

    unpublished: {
      title: 'Avaldamata',
      info: 'Töökuulutust ei ole veel avaldatud',
    },
  },

  page: {},

}
